export const TITLE_DATA_SUCCESS = 'TITLE_DATA_SUCCESS';
export const CLEAR_TITLE_DATA = 'CLEAR_TITLE_DATA';

export const loadTitleDataSuccess = payload => ({
  type: TITLE_DATA_SUCCESS,
  payload,
});

export const clearTitleData = uid => ({
  type: CLEAR_TITLE_DATA,
  payload: uid,
});



// WEBPACK FOOTER //
// ./src/actions/titleActions.js